define('boxes/helpers/doLogin',['jquery', 'all/player/session'], function($, session) {
    'use strict';

    function doLogin(response, afterSuccessfulLoginCallback) {

        // TODO: This is more or less copy-paste from login.doLogin(), but login.js could not be required here.

        var $loginBar = $('#cnt-login-bar');

        if ($loginBar.find('#rememberusername').not(':checked').length > 0) {
            var $userField = $loginBar.find('#loginusername');
            $userField.val('');
            showHideLabel($userField);
        }
        var $passwordField = $loginBar.find('#loginpassword');
        $passwordField.val('');
        showHideLabel($passwordField);

        try {
            localStorage.setItem('isCustomer', 'true');
        } catch (e) {
        }

        // show maintenance message if maintenance is coming soon
        if (response.MAINTENANCE) {
            dialog.load('info', {
                title: response.HEADER_MAINTENANCE,
                heading: response.IN_HEADER,
                message: response.IN_MESSAGE
            });
        }

        $('#clock').data('offset', response.PARAM_TIME_ZONE);

        window.playerinfo.init(response.PARAM_PLAYER_INFO);
        session.login();

        if(afterSuccessfulLoginCallback !== undefined){
            afterSuccessfulLoginCallback();
        }
    }


    // toggle label based on if field is empty or not
    function showHideLabel($input) {
        var reqId = $input.attr('id');
        if (reqId === 'loginusername' || reqId === 'loginpassword') {
            var $label = $('label[for="' + $input.attr('id') + '"]');
            if ($input.val().length === 0) {
                $label.css('visibility', 'visible');
            } else {
                $label.css('visibility', 'hidden');
            }
        }
    }
    return {
        doLogin: doLogin
    };
});
